import {iniciarRequisicao, logout} from "@/helpers";
import api from "@/api/api";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarEmails = async () => {
  const headers = iniciarRequisicao();
  const {data, status} = await api.get('drp/separacao-automatica/emails', {headers}).catch(logout)

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.grupos_filiais;
  }

  logout();
}

export const salvarEmails = async (params) => {
  const headers = iniciarRequisicao();
  const {data, status} = await api.post('drp/separacao-automatica/emails', params,{headers}).catch(logout)

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const excluirEmails = async (params) => {
  const headers = iniciarRequisicao();
  const {data, status} = await api.delete('drp/separacao-automatica/emails/exclusao', {params, headers}).catch(logout)

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const enviarEmails = async (params) => {
  const headers = iniciarRequisicao();
  const {data, status} = await api.get('drp/separacao-automatica/emails/enviar', {params, headers}).catch(logout)

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
